export default "__VITE_ASSET__fab16bed__"